<template>
  <div class="colorful-background wrapper-grid special">
    <div :class="['title', { animate__animated: isFirst }, 'animate__flipInX']">
      <span class="up-small-font">
        您获得了
      </span>
      <span class="big-font">
        {{ rewardsNum
        }}<span class="up-small-font">
          次奖学金
        </span>
      </span>
    </div>

    <div :class="['img', { animate__animated: isFirst }, 'animate__fadeIn']">
      <image-box class="image-box-position" img-u-r-l="/pic/6.png"></image-box>
    </div>

    <div
      :class="[
        'text',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'text-align-left',
      ]"
      style="align-items: flex-start;"
    >
      <span class="small-font">您获得的奖学金包括</span>

      <span v-if="rewardsForShow.length > 0" class="middle-font too-long-text">
        {{ rewardsForShow[0].REWARDLEVEL }}{{ rewardsForShow[0].REWARDNAME }}
      </span>
      <!--      todo:外层div有副作用？-->
      <span class="small-font" v-if="rewardsForShow.length > 1">
        和
      </span>

      <span class="middle-font too-long-text" v-if="rewardsForShow.length > 1">
        {{ rewardsForShow[1].REWARDLEVEL }}{{ rewardsForShow[1].REWARDNAME }}
      </span>
    </div>

    <div :class="['slogan', { animate__animated: isFirst }, 'animate__fadeIn']">
      <span class="small-font big-margin-top">{{ sloganForShow }}</span>
    </div>

    <div class="footer middle-margin-bottom">
      <span class="very-small-font">奖学金数据由杭电教务处提供</span>
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'RewardsPage',
  components: { ImageBox },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  data() {
    return {
      errno: null,
      sloganForShow: '拿到奖学金的你是最棒哒',
      sloganList: [
        '拿到奖学金的你是最棒哒',
        '拿到省奖的你，棒棒哒，来自小助手的肯定',
        '是国奖！大佬给小助手也整一份呗',
      ],
      //每一种奖项的权重
      weightMap: new Map([
        ['国家级', 3],
        ['省级', 2],
        ['校级', 1],
      ]),
    }
  },
  computed: {
    rewards: function () {
      return store.state.$data.data.Rewards
    },
    rewardsNum: function () {
      return this.rewards.length
    },
    //根据rewards权重map排序，并确定显示哪两项(或一项)奖学金
    rewardsForShow: function () {
      let tempArray = this.rewards
      let tempMap = this.weightMap
      if (tempArray.length <= 1) {
        return tempArray
      } else {
        tempArray.sort(function (data1, data2) {
          if (tempMap.get(data1.REWARDLEVEL) === undefined) {
            tempMap.set(data1.REWARDLEVEL, 0)
          }
          if (tempMap.get(data2.REWARDLEVEL) === undefined) {
            tempMap.set(data2.REWARDLEVEL, 0)
          }
          if (
            tempMap.get(data1.REWARDLEVEL) >= tempMap.get(data2.REWARDLEVEL)
          ) {
            return -1
          } else {
            return 1
          }
        })
        let tempList = []
        tempList.push(tempArray[0])
        tempList.push(tempArray[1])

        this.chooseSlogan(tempArray[0])

        return tempList
      }
    },
  },
  methods: {
    chooseSlogan(reward) {
      if (reward.REWARDLEVEL === '校级') {
        this.sloganForShow = this.sloganList[0]
      } else if (reward.REWARDLEVEL === '省级') {
        this.sloganForShow = this.sloganList[1]
      } else if (reward.REWARDLEVEL === '国家级') {
        this.sloganForShow = this.sloganList[2]
      } else {
        this.sloganForShow = this.sloganList[1]
      }
    },
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--first-delay);
}

.text.animate__animated {
  animation-delay: var(--second-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.wrapper-grid.special {
  --angle: 45deg;
  --second-color: var(--eggplant-purple);
  --first-color: var(--rose-gold);
  --page-background-color: var(--hdu-school-blue);
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. title  .'
    '. img    .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
